/* REACT */
import React from 'react'
import { connect } from 'react-redux'

/* 3RD PARTIES */

/* COMPONENTS */
import { Spinner } from '../../../../components/ui'
import TripsGridLoader from '../../../../components/grids/trips/Loader'
import AccomodationsGridLoader from '../../../../components/grids/accomodations/Loader'

import { Mail, RefreshCw } from 'lucide-react'

/* STORE */
import {
  requestPlan,
  setIsGridMode,
  refreshChat,
} from '../../../../store/maya/actions'
import { setShowSendChatModal } from '../../../../store/general/actions'

/* STYLES */
import {
  ShowIntentWrapper,
  IntentRecommendationWrapper,
  RequestPlanCta,
  RequestPlanCtaLink,
  RequestPlanCtaWrapper,
  MayaEmptyMarginContainer,
  RefreshIconWrapper,
  ShareIconWrapper,
  PoweredByMayaWrapper,
  PoweredByMayaLink,
  PoweredByMayaText,
  ShowIntentCtaWrapper,
  RefreshIconMobileWrapper,
  ShareIconMobileWrapper,
  IconsRow,
} from './style'

/* UTILS/CONSTANTS/IMAGES-ASSETS */
import { CLIENT_STYLINGS } from '../../../../utils/constants'
import { Analytics, getTranslations } from '../../../../utils'

const ShowIntentComponent = ({
  router,
  isLessThanLaptop,
  grids,
  language,
  organizationSlug,
  intent,
  isFetchingIntent,
  slug,
  token,
  readOnlyMode,
  setIsGridMode,
  organizationDetails,
  isPlanRequested,
  isChatReady,
  isMayaResponding,
  setShowSendChatModal,
}) => {
  const brandColor = CLIENT_STYLINGS[organizationSlug].COLOR.PRIMARY

  const onRequestPlanClick = () => {
    Analytics.getInstance().sendEvent('maya_sent_message', {
      message_type: 'cta',
      message_subtype: 'leave_details',
    })

    requestPlan({ slug, token })
    setIsGridMode(false)
  }

  const onContinueChatClick = () => {
    setIsGridMode(false)
  }

  const getAccomodationsGrid = () => {
    if (!grids?.accomodations) return null

    let grid = grids?.accomodations

    return (
      <AccomodationsGridLoader
        id={grid?.id}
        title={grid?.title}
        items={grid?.items}
        random_match={grid?.random_match}
        isLessThanLaptop={isLessThanLaptop}
        router={router}
        key={grid?.title}
        language={language}
        showRelevancyInfo={organizationDetails?.showRelevancyInfo}
        organizationSlug={organizationSlug}
        itemsPerRow={2}
        itemsPerPage={8}
        isChatMode={true}
      />
    )
  }

  const getTripsGrid = () => {
    if (!grids?.trips) return null

    let grid = grids?.trips
    return (
      <TripsGridLoader
        id={grid?.id}
        title={grid?.title}
        items={grid?.items}
        random_match={grid?.random_match}
        isLessThanLaptop={isLessThanLaptop}
        router={router}
        key={grid?.title}
        language={language}
        showRelevancyInfo={organizationDetails?.showRelevancyInfo}
        organizationSlug={organizationSlug}
        itemsPerRow={2}
        itemsPerPage={8}
        isChatMode={true}
      />
    )
  }

  const showPoweredByMaya = () => {
    // Find the first element with a non-null showPoweredByMayaButton value
    const poweredByMayaElement = organizationDetails?.configs?.find(
      element => element.showPoweredByMayaButton !== null
    )

    // Get the showPoweredByMayaButton value if found
    const canShowPoweredByMaya = poweredByMayaElement
      ? poweredByMayaElement.showPoweredByMayaButton
      : null

    return canShowPoweredByMaya
  }
  return (
    <ShowIntentWrapper id='show-intent-wrapper'>
      <IntentRecommendationWrapper
        id='intent-recommendation-wrapper'
        $canScroll={isFetchingIntent ? false : true}
      >
        {isFetchingIntent ? (
          <div
            style={{
              width: '100%',
              height: '100%',
            backgroundColor:
              CLIENT_STYLINGS[organizationSlug].COLOR.BACKGROUND,
              opacity: '0.8',
              zIndex: '100',
              position: 'absolute',
            }}
          >
            {' '}
            <Spinner
              isBasic={false}
              interval={10000}
              messages={getTranslations(
                `updating_recommendations_${intent?.type}`
              )}
            />
          </div>
        ) : null}

        {getTripsGrid()}
        {getAccomodationsGrid()}
      </IntentRecommendationWrapper>

      <ShowIntentCtaWrapper>
        <RequestPlanCtaWrapper>
          {!readOnlyMode ? (
            <>
              {isLessThanLaptop ? (
                <RequestPlanCta
                  onClick={() => {
                    Analytics.getInstance().sendEvent('maya_click_button', {
                      button_type: 'cta',
                      button_text: getTranslations('continue_chat_cta'),
                      button_subtype: 'continue_chatting',
                    })
                    onContinueChatClick()
                  }}
                  disabled={isPlanRequested || isMayaResponding || !isChatReady}
                >
                  {getTranslations('continue_chat_cta')}
                </RequestPlanCta>
              ) : null}

              {organizationDetails?.configs?.length &&
              organizationDetails?.configs[0]
                .enableRequestPlanCtaFullPageDesktop ? (
                organizationDetails?.configs[0].requestPlanUrl ? (
                  <RequestPlanCtaLink
                    href={organizationDetails.configs[0].requestPlanUrl}
                    onClick={() => {
                      Analytics.getInstance().sendEvent('maya_click_button', {
                        button_type: 'cta',
                        button_text: getTranslations('request_plan_cta'),
                        button_subtype: 'leave_details',
                      })
                    }}
                  >
                    {getTranslations('request_plan_cta')}
                  </RequestPlanCtaLink>
                ) : (
                  <RequestPlanCta
                    onClick={() => {
                      Analytics.getInstance().sendEvent('maya_click_button', {
                        button_type: 'cta',
                        button_text: getTranslations('request_plan_cta'),
                        button_subtype: 'leave_details',
                      })
                      onRequestPlanClick()
                    }}
                    disabled={
                      isPlanRequested || isMayaResponding || !isChatReady
                    }
                  >
                    {!isPlanRequested
                      ? getTranslations('request_plan_cta')
                      : getTranslations('is_plan_requested')}
                  </RequestPlanCta>
                )
              ) : null}
            </>
          ) : null}

          {!isLessThanLaptop ? (
            <IconsRow>
              <ShareIconWrapper
                onClick={() => {
                  setShowSendChatModal(true)
                }}
              >
                <Mail size={22} strokeWidth={2} color={brandColor} />
              </ShareIconWrapper>
              <RefreshIconWrapper
                onClick={() => {
                  Analytics.getInstance().sendEvent('maya_click_button', {
                    button_type: 'restart',
                  })
                  refreshChat()
                  if (
                    organizationDetails?.configs?.length &&
                    organizationDetails?.configs[0]?.chatUrl
                  ) {
                    window.location.href =
                      organizationDetails.configs[0].chatUrl
                  }
                }}
              >
                <RefreshCw size={22} strokeWidth={2} color={brandColor} />
              </RefreshIconWrapper>
            </IconsRow>
          ) : null}
        </RequestPlanCtaWrapper>

        {!isLessThanLaptop && showPoweredByMaya() ? (
          <PoweredByMayaWrapper>
            <PoweredByMayaText> Powered by</PoweredByMayaText>{' '}
            <PoweredByMayaLink
              href={'https://www.mayatravel.ai/'}
              target={'_blank'}
            >
              Maya
            </PoweredByMayaLink>
          </PoweredByMayaWrapper>
        ) : null}
        {isLessThanLaptop ? (
          <IconsRow>
            <ShareIconMobileWrapper
              onClick={() => {
                setShowSendChatModal(true)
              }}
            >
              <Mail size={24} strokeWidth={2} color={brandColor} />
            </ShareIconMobileWrapper>
            <RefreshIconMobileWrapper
              onClick={() => {
                Analytics.getInstance().sendEvent('maya_click_button', {
                  button_type: 'restart',
                })
                refreshChat()
                if (
                  organizationDetails?.configs?.length &&
                  organizationDetails?.configs[0]?.chatUrl
                ) {
                  window.location.href = organizationDetails.configs[0].chatUrl
                }
              }}
            >
              <RefreshCw size={24} strokeWidth={2} color={brandColor} />
            </RefreshIconMobileWrapper>
          </IconsRow>
        ) : null}
      </ShowIntentCtaWrapper>

      <MayaEmptyMarginContainer />
    </ShowIntentWrapper>
  )
}

const mapStateToProps = state => {
  return {
    isPlanRequested: state?.maya?.isPlanRequested,
    readOnlyMode: state?.maya?.readOnlyMode,
    slug: state?.maya?.slug,
    token: state?.maya?.token,
    intent: state?.maya?.intent,
    isFetchingIntent: state?.maya?.isFetchingIntent,
    planRequested: state?.maya?.planRequested,
    organizationDetails: state?.maya?.organizationDetails,
    isChatReady: state?.maya?.isChatReady,
    isMayaResponding: state?.maya?.isMayaResponding,
  }
}

const mapDispatchToProps = dispatch => ({
  setIsGridMode: data => dispatch(setIsGridMode(data)),
  setShowSendChatModal: isOpen => dispatch(setShowSendChatModal(isOpen)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ShowIntentComponent)
